import script from "./NotificationFullView.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationFullView.vue?vue&type=script&setup=true&lang=js"

import "./NotificationFullView.vue?vue&type=style&index=0&id=2c6ce92e&scoped=true&lang=css"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6ce92e"]])

export default __exports__